import React from 'react';
import { ReactComponent as Facebook } from '../images/social/facebook.svg';
import { ReactComponent as Pinterest } from '../images/social/pinterest.svg';
import { ReactComponent as Instagram } from '../images/social/instagram.svg';
import { ReactComponent as Linkedin } from '../images/social/linkedin.svg';
import { ReactComponent as Youtube } from '../images/social/youtube.svg';

export default function Social() {
  return (
    <>
    <div className='col-auto'><a alt='Facebook' href='https://www.facebook.com/poolsidebycgt' target='_blank' rel='noreferrer'><Facebook /></a></div>
    <div className='col-auto'><a alt='Pinterest' href='http://www.pinterest.com/poolsidebycgt' target='_blank' rel='noreferrer'><Pinterest /></a></div>
    <div className='col-auto'><a alt='Instagram' href='https://www.instagram.com/poolsidebycgt/' target='_blank' rel='noreferrer'><Instagram /></a></div>
    <div className='col-auto'><a alt='Linkedin' href='https://www.linkedin.com/showcase/poolside-by-cgt' target='_blank' rel='noreferrer'><Linkedin /></a></div>
    <div className='col-auto'><a alt='Youtube' href='https://www.youtube.com/channel/UC9QlA6mPRlfucWoVjsrezbA' target='_blank' rel='noreferrer'><Youtube /></a></div>
    </>
  );
}
